<div class="login-page">
  <div class="login-card">
    <h1>WatchDog</h1>
    <p class="sub">AI-augmented test automation</p>

    <p class="checking" *ngIf="checking">Checking your session…</p>

    <ng-container *ngIf="!checking">
      <button mat-raised-button color="primary" class="signin" (click)="signIn()">
        Sign in
      </button>
      <p class="hint">You will be redirected to your organisation's sign-in page.</p>
    </ng-container>

    <div class="banner err" *ngIf="error">{{ error }}</div>
  </div>
</div>
